import { render, staticRenderFns } from "./BaseView.vue?vue&type=template&id=6b06c956&scoped=true&"
var script = {}
import style0 from "./BaseView.vue?vue&type=style&index=0&id=6b06c956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06c956",
  null
  
)

export default component.exports